import { sortNamesBy } from "logic/sortNames";
import { LangCode } from 'shared/models';
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { LegacySelectField } from "ui/shared/controls";

export type Props = {
    id: string;
    className?: string;
    name: string;
    disabled?: boolean;
    readOnly?: boolean;
    labelKey: string;
    required?: boolean;
    value: LangCode | null;
    excludedOptions?: LangCode[];
    onChange(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>): void;
};

const nullSelectValue = 'none';

export const LanguageSelectField = ({ id, className, name, labelKey, required = false, value, disabled = false, readOnly = false, excludedOptions = [], onChange }: Props) => {
    const { t } = useTranslation();
    const langCodes =  Object.keys(LangCode) as LangCode[];

    return (
        <LegacySelectField
            id={ id }
            className={ className }
            labelKey={ labelKey }
            required={ required }
            disabled={ disabled }
            readOnly={ readOnly }
            input={ {
                name,
                value: required ? value! : value || nullSelectValue,
                onChange,
            } }
        >
            { !required &&
                <option value={ nullSelectValue }>
                    { t('NONE') }
                </option>
            }
            { langCodes
                .filter(langCode => excludedOptions.indexOf(langCode) === -1)
                .sort(sortNamesBy(langCode => t(`LANGUAGE.${langCode}`)))
                .map(langCode =>
                    <option key={ langCode } value={ langCode }>
                        { t([ `LANGUAGE.${langCode}` ]) }
                    </option>
                )
            }
        </LegacySelectField>
    );
};